/**
 * Allen Precision Equipment - Theme JavaScript
 *
 * Note: <product-form> custom element is registered synchronously in
 * sections/main-product.liquid so it's defined BEFORE third-party app
 * scripts (e.g. MW Bundle Builder) initialize.
 */

(function () {
  "use strict";

  // ─── Global fetch interceptor ──────────────────────────────────────────
  // Catches ANY /cart/add call (from MW Bundle Builder, other apps, or our
  // own form handler) and refreshes the cart drawer + badge. Skips refresh
  // when called from our own product-form handler (it triggers a refresh
  // explicitly afterward to coordinate the drawer-open timing).
  if (window.fetch && !window.__themeCartFetchPatched) {
    window.__themeCartFetchPatched = true;
    var __origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var isCartAdd = url && /\/cart\/add(\.js)?(\?|$)/.test(url);
      var p = __origFetch.apply(this, arguments);
      if (isCartAdd && !(init && init.__themeInternal)) {
        p.then(function (resp) {
          if (resp && resp.ok && typeof window.__themeRefreshCart === "function") {
            window.__themeRefreshCart();
          }
        }).catch(function () {});
      }
      return p;
    };
  }

  // Mobile menu toggle
  const mobileMenuBtn = document.querySelector("[data-mobile-menu-toggle]");
  const mobileDrawer = document.querySelector("[data-mobile-drawer]");
  const mobileDrawerClose = document.querySelector(
    "[data-mobile-drawer-close]",
  );

  if (mobileMenuBtn && mobileDrawer) {
    mobileMenuBtn.addEventListener("click", function () {
      mobileDrawer.showModal();
      document.body.style.overflow = "hidden";
      mobileMenuBtn.setAttribute("aria-expanded", "true");
    });

    if (mobileDrawerClose) {
      mobileDrawerClose.addEventListener("click", function () {
        mobileDrawer.close();
        document.body.style.overflow = "";
        mobileMenuBtn.setAttribute("aria-expanded", "false");
      });
    }

    mobileDrawer.addEventListener("close", function () {
      document.body.style.overflow = "";
      mobileMenuBtn.setAttribute("aria-expanded", "false");
    });

    mobileDrawer.addEventListener("click", function (e) {
      if (e.target === mobileDrawer) {
        mobileDrawer.close();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mobileDrawer.open) {
        mobileDrawer.close();
      }
    });
  }

  // Testimonial slider
  const testimonialSlider = document.querySelector(".testimonials__slider");
  if (testimonialSlider) {
    const slides = testimonialSlider.querySelectorAll(".testimonials__slide");
    const dots = testimonialSlider
      .closest(".testimonials")
      ?.querySelectorAll(".testimonials__dot");
    let currentSlide = 0;

    function showSlide(index) {
      slides.forEach(function (slide, i) {
        slide.style.display = i === index ? "block" : "none";
      });
      if (dots) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle("active", i === index);
        });
      }
      currentSlide = index;
    }

    if (dots) {
      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          showSlide(i);
        });
      });
    }

    // Auto-rotate every 5 seconds
    setInterval(function () {
      showSlide((currentSlide + 1) % slides.length);
    }, 5000);

    showSlide(0);
  }

  // Hero slider dots
  const heroDots = document.querySelectorAll(".hero-banner__dot");
  heroDots.forEach(function (dot, i) {
    dot.addEventListener("click", function () {
      heroDots.forEach(function (d) {
        d.classList.remove("active");
      });
      dot.classList.add("active");
    });
  });

  // Add to cart AJAX
  // document.addEventListener("submit", function (e) {
  //   const form = e.target;
  //   if (!form.matches(".product-card form, .product-card__actions form"))
  //     return;

  //   e.preventDefault();
  //   const button = form.querySelector('button[type="submit"]');
  //   const originalText = button.textContent;
  //   button.textContent = "Adding...";
  //   button.disabled = true;

  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     body: new URLSearchParams(new FormData(form)),
  //   }).then((response) => {
  //     console.log(response.json());
  //     return response.json();
  //   });
  //   // .then(function() {
  //   //   button.textContent = 'Added!';
  //   //   // Update cart count
  //   //   fetch('/cart.js')
  //   //     .then(function(r) { return r.json(); })
  //   //     .then(function(cart) {
  //   //       var badges = document.querySelectorAll('.header__cart-badge, [data-cart-count]');
  //   //       badges.forEach(function(badge) {
  //   //         badge.textContent = cart.item_count;
  //   //         badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
  //   //       });
  //   //     });
  //   //   setTimeout(function() {
  //   //     button.textContent = originalText;
  //   //     button.disabled = false;
  //   //   }, 1500);
  //   // })
  //   // .catch(function() {
  //   //   button.textContent = 'Error';
  //   //   setTimeout(function() {
  //   //     button.textContent = originalText;
  //   //     button.disabled = false;
  //   //   }, 1500);
  //   // });
  // });

  // Collect bundle (MW Bundle Builder) items.
  // The bundle ships as a web component <mw-bundle-product> with Shadow DOM.
  // We try multiple strategies because shadow DOM may be closed-mode.
  function getBundleElement() {
    return document.querySelector("mw-bundle-product");
  }

  function getBundleSearchRoot() {
    var el = getBundleElement();
    if (el && el.shadowRoot) return el.shadowRoot;
    return document.querySelector(".product-info__app-blocks");
  }

  // Try to read items directly from a JS property/method on the web component.
  function readBundleItemsFromComponentApi() {
    var el = getBundleElement();
    if (!el) return [];
    var candidates = [];

    // Try common method names
    var methods = ["getSelectedItems", "getItems", "getBundleItems", "getSelected", "getProducts"];
    for (var i = 0; i < methods.length; i++) {
      if (typeof el[methods[i]] === "function") {
        try {
          var r = el[methods[i]]();
          if (Array.isArray(r)) candidates = r;
          else if (r && Array.isArray(r.items)) candidates = r.items;
          if (candidates.length > 0) break;
        } catch (e) {}
      }
    }

    // Try common property names
    if (candidates.length === 0) {
      var props = ["items", "selectedItems", "bundleItems", "products", "selectedProducts"];
      for (var j = 0; j < props.length; j++) {
        if (Array.isArray(el[props[j]])) {
          candidates = el[props[j]];
          break;
        }
      }
    }

    var out = [];
    candidates.forEach(function (c) {
      if (!c) return;
      var id = c.variantId || c.variant_id || c.id || c.variant || (c.variant && c.variant.id);
      var qty = c.quantity || c.qty || c.count || 0;
      id = parseInt(id, 10);
      qty = parseInt(qty, 10);
      if (id && qty > 0) out.push({ id: id, quantity: qty });
    });
    return out;
  }

  function collectBundleItems() {
    // Strategy 0: Try JS API on the web component first
    var apiItems = readBundleItemsFromComponentApi();
    if (apiItems.length > 0) return apiItems;

    var items = [];
    var bundleArea = getBundleSearchRoot();
    if (!bundleArea) return items;

    function pushItem(id, qty) {
      id = parseInt(id, 10);
      qty = parseInt(qty, 10);
      if (!id || !qty || qty <= 0) return;
      // De-dupe — sum qty if same variant appears twice
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === id) {
          items[i].quantity += qty;
          return;
        }
      }
      items.push({ id: id, quantity: qty });
    }

    function findVariantIdInOrAround(el) {
      // 1. Direct attributes
      var attrs = ["data-variant-id", "data-product-variant-id", "data-bundle-variant-id", "data-id", "data-product-id"];
      for (var i = 0; i < attrs.length; i++) {
        var v = el.getAttribute(attrs[i]);
        if (v && /^\d+$/.test(v)) return v;
      }
      // 2. Walk up ancestors
      var p = el.parentElement;
      for (var d = 0; d < 8 && p && p !== document.body; d++) {
        for (var j = 0; j < attrs.length; j++) {
          var v2 = p.getAttribute(attrs[j]);
          if (v2 && /^\d+$/.test(v2)) return v2;
        }
        p = p.parentElement;
      }
      // 3. Look in nested elements
      for (var k = 0; k < attrs.length; k++) {
        var nested = el.querySelector("[" + attrs[k] + "]");
        if (nested) {
          var v3 = nested.getAttribute(attrs[k]);
          if (v3 && /^\d+$/.test(v3)) return v3;
        }
      }
      // 4. Look for ?variant=NNN in any href inside the row
      var links = el.querySelectorAll('a[href*="variant="]');
      for (var l = 0; l < links.length; l++) {
        var m = links[l].href.match(/[?&]variant=(\d+)/);
        if (m) return m[1];
      }
      return null;
    }

    function getRowQty(row) {
      // Try input element first
      var input = row.querySelector('input[type="number"], input[type="text"][class*="ItemQuantity"], input[class*="ItemQuantity"]');
      if (input) {
        var v = parseInt(input.value, 10);
        if (!isNaN(v) && v > 0) return v;
        if (!isNaN(v)) return 0;
      }
      // Look for displayed value between +/- buttons (span/div with just digits)
      var valueEl = row.querySelector('[class*="ItemQuantity__Value"], [class*="ItemQuantity__Input"], [class*="ItemQuantity__Display"], [class*="ItemQuantity__Number"]');
      if (valueEl) {
        var t = (valueEl.textContent || valueEl.value || "").trim();
        var n = parseInt(t, 10);
        if (!isNaN(n)) return n;
      }
      // Fallback: scan elements between Minus and Plus buttons for a numeric text node
      var btns = row.querySelectorAll('[class*="ItemQuantity__Button"], [aria-label="Plus"], [aria-label="Minus"]');
      if (btns.length >= 2) {
        var container = btns[0].parentElement;
        if (container) {
          var children = container.querySelectorAll("*");
          for (var i = 0; i < children.length; i++) {
            var txt = (children[i].textContent || "").trim();
            if (/^\d+$/.test(txt)) {
              return parseInt(txt, 10);
            }
          }
        }
      }
      return 0;
    }

    // Pattern A: Shopify multi-item form syntax — search bundle area, the
    // main product form, AND the entire document (in case the bundle injects
    // hidden items[N] inputs anywhere outside the bundle widget).
    var scanRoots = [bundleArea, document.getElementById("ProductForm"), document];
    for (var sr = 0; sr < scanRoots.length; sr++) {
      var root = scanRoots[sr];
      if (!root || (root.querySelectorAll === undefined)) continue;
      var idInputs = root.querySelectorAll('input[name^="items["][name$="[id]"]');
      if (idInputs.length > 0) {
        idInputs.forEach(function (idInput) {
          var match = idInput.name.match(/items\[(\d+)\]\[id\]/);
          if (!match) return;
          var qInput = root.querySelector('input[name="items[' + match[1] + '][quantity]"]');
          pushItem(idInput.value, qInput ? qInput.value : 1);
        });
        if (items.length > 0) return items;
      }
    }

    // Pattern B (primary for MW Bundle Builder):
    // Each bundle row uses class "BundleProduct". Iterate rows directly.
    var rows = bundleArea.querySelectorAll('[class*="BundleProduct"]:not([class*="BundleProduct__"])');
    if (rows.length === 0) {
      rows = bundleArea.querySelectorAll('.BundleProduct, [class*="BundleItem"], [class*="Item__Container"], [class*="Item__Row"]');
    }
    rows.forEach(function (row) {
      // Skip nested children that also matched
      var qty = getRowQty(row);
      if (qty <= 0) return;
      var variantId = findVariantIdInOrAround(row);
      if (variantId) pushItem(variantId, qty);
    });
    if (items.length > 0) return items;

    // Pattern B-fallback: walk up from each Plus button to find row with title + price
    var qtyButtons = bundleArea.querySelectorAll('[class*="ItemQuantity__Button"], [aria-label="Plus"]');
    var processed = new Set();
    qtyButtons.forEach(function (btn) {
      var row = btn.parentElement;
      var hops = 0;
      while (row && hops < 10) {
        var hasTitle = row.querySelector('[class*="Item__Title"], [class*="ItemTitle"], [class*="Item__Name"], [class*="ItemName"], [class*="BundleProduct__Title"], [class*="BundleProduct__Name"]');
        var hasPrice = row.querySelector('[class*="BundleProduct__Price"], [class*="ItemPrice"], [class*="Item__Price"]');
        var hasVariantData = row.hasAttribute("data-variant-id") || row.hasAttribute("data-product-variant-id") || row.querySelector("[data-variant-id], [data-product-variant-id]");
        if ((hasTitle && hasPrice) || hasVariantData || (row.className && /\bBundleProduct\b/.test(row.className))) break;
        row = row.parentElement;
        hops++;
      }
      if (!row || processed.has(row)) return;
      processed.add(row);
      var qty = getRowQty(row);
      if (qty <= 0) return;
      var variantId = findVariantIdInOrAround(row);
      if (variantId) pushItem(variantId, qty);
    });
    if (items.length > 0) return items;

    // Pattern C (last-resort): any number input with positive value, walk up for id.
    bundleArea.querySelectorAll('input[type="number"]').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      if (qty <= 0) return;
      var variantId = findVariantIdInOrAround(input);
      if (variantId) pushItem(variantId, qty);
    });

    return items;
  }

  // Add items to the cart while consolidating duplicates by variant_id.
  //
  // Why: Shopify's POST /cart/add.js only merges a new add with an existing
  // line when the line item properties match. The MW Bundle Builder (group
  // product) widget can inject differing properties on subsequent renders,
  // so the same variant ends up as separate rows in the drawer. We force
  // consolidation here by:
  //   - reading the current cart,
  //   - bumping the quantity on the existing line via /cart/change.js for
  //     any variant already in the cart,
  //   - adding only genuinely new variants via /cart/add.js.
  function addOrIncrementItems(items) {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
      __themeInternal: true,
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = {};
        (cart.items || []).forEach(function (line) {
          // First matching line wins — that's the line we consolidate into.
          if (!existing[line.variant_id]) {
            existing[line.variant_id] = { key: line.key, quantity: line.quantity };
          }
        });

        var newItems = [];
        var updatesByKey = {};

        items.forEach(function (item) {
          if (!item || !item.id || !item.quantity) return;

          // Selling-plan items must keep their own line — let Shopify handle them.
          if (item.selling_plan) {
            newItems.push(item);
            return;
          }

          var match = existing[item.id];
          if (match && match.key) {
            match.quantity += item.quantity;
            updatesByKey[match.key] = match.quantity;
          } else if (match) {
            // Same variant already queued as a new add in this batch — fold into it.
            for (var i = 0; i < newItems.length; i++) {
              if (newItems[i].id === item.id && !newItems[i].selling_plan) {
                newItems[i].quantity += item.quantity;
                match.quantity += item.quantity;
                return;
              }
            }
          } else {
            existing[item.id] = { key: null, quantity: item.quantity };
            newItems.push({ id: item.id, quantity: item.quantity });
          }
        });

        var chain = Promise.resolve();

        if (newItems.length > 0) {
          chain = chain.then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: newItems }),
              __themeInternal: true,
            });
          });
        }

        // Sequential to avoid racing the cart state across multiple line updates.
        Object.keys(updatesByKey).forEach(function (key) {
          chain = chain.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: key, quantity: updatesByKey[key] }),
              __themeInternal: true,
            });
          });
        });

        return chain;
      });
  }

  function refreshCartDrawer(button) {
    return Promise.all([
      fetch("/?sections=cart-drawer", { __themeInternal: true }).then(function (r) { return r.json(); }),
      fetch("/cart.js", { __themeInternal: true }).then(function (r) { return r.json(); }),
    ]).then(function (results) {
      var sections = results[0];
      var cart = results[1];

      var parser = new DOMParser();
      var doc = parser.parseFromString(sections["cart-drawer"], "text/html");

      var newBody = doc.querySelector(".cart-drawer__body");
      var oldBody = document.querySelector(".cart-drawer__body");
      if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;

      var newFooter = doc.querySelector(".cart-drawer__footer");
      var oldFooter = document.querySelector(".cart-drawer__footer");
      if (newFooter && oldFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      } else if (newFooter && !oldFooter) {
        document.getElementById("CartDrawer").appendChild(newFooter);
      }

      var badge = document.querySelector("[data-cart-count]");
      if (badge) badge.textContent = cart.item_count;

      if (button) {
        button.classList.remove("loading");
        button.disabled = false;
      }
      document.dispatchEvent(new CustomEvent("cart:open"));
    });
  }

  // Expose for the global fetch interceptor (third-party cart adds, e.g. bundle's own button).
  window.__themeRefreshCart = refreshCartDrawer;

  // Trigger the bundle widget's own add-to-cart flow when we cannot scrape items
  // (shadow DOM closed / no JS API). Tries the most common patterns; the global
  // fetch interceptor catches whatever /cart/add calls result.
  function triggerBundleAddToCart(bundleEl) {
    if (!bundleEl) return;

    // 1. Dispatch common events the bundle might listen for on document/window/element
    var eventNames = [
      "mw-bundle:add-to-cart",
      "mwbb:add-to-cart",
      "bundle:add-to-cart",
      "product:add-to-cart",
      "cart:add",
    ];
    eventNames.forEach(function (name) {
      try {
        bundleEl.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true }));
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (e) {}
    });

    // 2. Call common methods on the element if exposed
    var methods = ["addToCart", "submit", "addBundle", "add"];
    for (var i = 0; i < methods.length; i++) {
      if (typeof bundleEl[methods[i]] === "function") {
        try { bundleEl[methods[i]](); } catch (e) {}
      }
    }

    // 3. If shadow DOM is open, look for an internal "Add" button and click it
    var root = bundleEl.shadowRoot;
    if (root) {
      var btn = root.querySelector(
        '[class*="AddToCart"], [class*="addToCart"], [class*="AddBundle"], button[type="submit"]'
      );
      if (!btn) {
        // Fallback: any button whose text mentions add/cart/bundle
        var buttons = root.querySelectorAll("button");
        for (var j = 0; j < buttons.length; j++) {
          var t = (buttons[j].textContent || "").toLowerCase();
          if (/add|cart|bundle/.test(t)) { btn = buttons[j]; break; }
        }
      }
      if (btn) {
        try { btn.click(); } catch (e) {}
      }
    }
  }

  // Add to cart AJAX for forms with action="/cart/add"
  document
    .querySelectorAll('form[action="/cart/add"]')
    .forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        button.classList.add("loading");
        button.disabled = true;

        var formData = new FormData(form);
        var mainItem = {
          id: parseInt(formData.get("id"), 10),
          quantity: parseInt(formData.get("quantity"), 10) || 1,
        };
        var sellingPlan = formData.get("selling_plan");
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        var bundleItems = collectBundleItems(form);
        var bundleEl = getBundleElement();

        var allItems = bundleItems.length > 0
          ? [mainItem].concat(bundleItems)
          : [mainItem];

        // Suppress the inline interceptor's own drawer refresh — we'll
        // refresh once at the end via refreshCartDrawer(button) below so
        // the button loading state and drawer-open timing stay coordinated.
        window.__themeFormHandling = true;

        addOrIncrementItems(allItems)
          .then(function () {
            window.__themeFormHandling = false;
            // If the bundle widget is present and we couldn't scrape items
            // (closed shadow DOM, no JS API), give the bundle a chance to add
            // its own items by triggering its likely interaction points.
            // Any /cart/add it fires is caught by the global fetch interceptor.
            if (bundleEl && bundleItems.length === 0) {
              triggerBundleAddToCart(bundleEl);
              // Wait a moment for the bundle's async cart adds before refreshing
              return new Promise(function (resolve) {
                setTimeout(function () {
                  refreshCartDrawer(button).then(resolve, resolve);
                }, 600);
              });
            }
            return refreshCartDrawer(button);
          })
          .catch(function () {
            window.__themeFormHandling = false;
            button.classList.remove("loading");
            button.disabled = false;
          });
      });
    });

  // --- FOUC: Image cached-image check (belt-and-suspenders for cache hits) ---
  document.querySelectorAll('.img--loading').forEach(function(img) {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.remove('img--loading');
      img.classList.add('img--loaded');
      var wrapper = img.closest('.product-card__image-wrapper');
      if (wrapper) wrapper.classList.remove('product-card__image-wrapper--loading');
    }
  });

  // --- FOUC: Yotpo skeleton — MutationObserver per widget instance ---
  (function() {
    var TIMEOUT_MS = 5000;

    function resolveYotpoSkeleton(widgetEl) {
      var skeleton = widgetEl.querySelector('.product-card__rating-skeleton');
      if (!skeleton) return;
      skeleton.classList.add('product-card__rating-skeleton--hiding');
      skeleton.addEventListener('transitionend', function() {
        if (skeleton.parentNode) skeleton.parentNode.removeChild(skeleton);
      }, { once: true });
      setTimeout(function() {
        if (skeleton.parentNode) skeleton.parentNode.removeChild(skeleton);
      }, 400);
    }

    document.querySelectorAll('.yotpo-widget-instance').forEach(function(widgetEl) {
      if (!widgetEl.querySelector('.product-card__rating-skeleton')) return;
      var timeoutId;
      var observer = new MutationObserver(function() {
        var hasYotpoContent = Array.prototype.some.call(widgetEl.children, function(child) {
          return !child.classList.contains('product-card__rating-skeleton');
        });
        if (hasYotpoContent) {
          clearTimeout(timeoutId);
          observer.disconnect();
          resolveYotpoSkeleton(widgetEl);
        }
      });
      observer.observe(widgetEl, { childList: true, subtree: false });
      timeoutId = setTimeout(function() {
        observer.disconnect();
        resolveYotpoSkeleton(widgetEl);
      }, TIMEOUT_MS);
    });
  })();
})();

// ─── Quick View Modal ──────────────────────────────────────────────────────
(function () {
  'use strict';

  var overlay  = document.getElementById('QvOverlay');
  var modal    = document.getElementById('QvModal');
  var body     = document.getElementById('QvModalBody');
  var loading  = document.getElementById('QvModalLoading');
  var closeBtn = document.getElementById('QvModalClose');

  if (!overlay || !modal) return;

  function openModal() {
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (modal._triggerBtn) {
      modal._triggerBtn.focus();
      modal._triggerBtn = null;
    }
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  function showLoading() {
    loading.style.display = '';
    var prev = body.querySelector('.qv-inner');
    if (prev) prev.remove();
  }

  function hideLoading() {
    loading.style.display = 'none';
  }

  var fetchCache = {};

  function fetchProduct(handle) {
    if (fetchCache[handle]) return Promise.resolve(fetchCache[handle]);
    return fetch('/products/' + handle + '?section_id=quick-view')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        fetchCache[handle] = html;
        return html;
      });
  }

  function injectContent(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var inner = doc.querySelector('.qv-inner');
    if (!inner) {
      console.warn('Quick view: .qv-inner not found in response');
      hideLoading();
      return;
    }
    body.appendChild(inner);
    hideLoading();
    wireGallery(inner);
    wireVariants(inner);
    wireQty(inner);
    wireAtc(inner);
    wireYotpoSkeleton(inner);
    reinitYotpo(inner);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-quick-view');
    if (!handle) return;
    modal._triggerBtn = btn;
    showLoading();
    openModal();
    fetchProduct(handle)
      .then(injectContent)
      .catch(function (err) {
        console.error('Quick view fetch error:', err);
        hideLoading();
        body.innerHTML = '<div class="qv-modal__loading"><p style="color:#c00;">Could not load product. Please try again.</p></div>';
      });
  }, true);

  function wireGallery(inner) {
    var mainImg = inner.querySelector('#QvMainImage');
    var wrapper = inner.querySelector('.qv-gallery__main');
    var thumbs = inner.querySelectorAll('.qv-gallery__thumb');
    if (!mainImg) return;

    // Belt-and-suspenders: clear shimmer if main image already cached
    if (mainImg.complete && mainImg.naturalWidth > 0) {
      mainImg.classList.remove('img--loading');
      mainImg.classList.add('img--loaded');
      if (wrapper) wrapper.classList.remove('qv-gallery__main--loading');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        // Re-apply shimmer while new image loads
        mainImg.classList.remove('img--loaded');
        mainImg.classList.add('img--loading');
        if (wrapper) wrapper.classList.add('qv-gallery__main--loading');

        mainImg.onload = function () {
          mainImg.classList.remove('img--loading');
          mainImg.classList.add('img--loaded');
          if (wrapper) wrapper.classList.remove('qv-gallery__main--loading');
          mainImg.onload = null;
        };
        mainImg.src = thumb.getAttribute('data-image-url');
        mainImg.alt = thumb.getAttribute('data-image-alt') || '';
      });
    });
  }

  function wireVariants(inner) {
    var selects = inner.querySelectorAll('.qv-info__variant-select');
    var variantIdInput = inner.querySelector('[data-qv-variant-id]');
    var priceEl = inner.querySelector('[data-qv-price]');
    var compareEl = inner.querySelector('[data-qv-compare-price]');
    var submitBtn = inner.querySelector('.qv-info__atc-btn');
    var jsonEl = inner.querySelector('[data-qv-variants-json]');

    if (!selects.length || !variantIdInput || !jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    function getOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) {
          return v['option' + (i + 1)] === val;
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try { return window.Shopify.formatMoney(cents); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var variant = findVariant(getOptions());
      if (!variant) { if (submitBtn) submitBtn.disabled = true; return; }
      variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) submitBtn.disabled = !variant.available;
    }

    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  function wireQty(inner) {
    var input = inner.querySelector('[data-qv-qty-input]');
    var minus = inner.querySelector('[data-qv-qty-minus]');
    var plus = inner.querySelector('[data-qv-qty-plus]');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        if (v > 1) input.value = v - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    }
  }

  function wireAtc(inner) {
    var form = inner.querySelector('.qv-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('.qv-info__atc-btn');
      button.classList.add('loading');
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return Promise.all([
            fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }),
            fetch('/cart.js').then(function (r) { return r.json(); }),
          ]);
        })
        .then(function (results) {
          var sections = results[0];
          var cart = results[1];
          var parser = new DOMParser();
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newBody = doc.querySelector('.cart-drawer__body');
          var oldBody = document.querySelector('.cart-drawer__body');
          if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
          var newFooter = doc.querySelector('.cart-drawer__footer');
          var oldFooter = document.querySelector('.cart-drawer__footer');
          if (newFooter && oldFooter) {
            oldFooter.innerHTML = newFooter.innerHTML;
          } else if (newFooter && !oldFooter) {
            document.getElementById('CartDrawer').appendChild(newFooter);
          }
          var badge = document.querySelector('[data-cart-count]');
          if (badge) badge.textContent = cart.item_count;
          button.classList.remove('loading');
          button.disabled = false;
          closeModal();
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function () {
          button.classList.remove('loading');
          button.disabled = false;
        });
    });
  }

  function wireYotpoSkeleton(inner) {
    var TIMEOUT_MS = 5000;
    inner.querySelectorAll('.yotpo-widget-instance').forEach(function (widgetEl) {
      var skeleton = widgetEl.querySelector('.product-card__rating-skeleton');
      if (!skeleton) return;

      function removeSkeleton() {
        skeleton.classList.add('product-card__rating-skeleton--hiding');
        skeleton.addEventListener('transitionend', function () {
          if (skeleton.parentNode) skeleton.parentNode.removeChild(skeleton);
        }, { once: true });
        setTimeout(function () {
          if (skeleton.parentNode) skeleton.parentNode.removeChild(skeleton);
        }, 400);
      }

      var timeoutId;
      var observer = new MutationObserver(function () {
        var hasYotpoContent = Array.prototype.some.call(widgetEl.children, function (child) {
          return !child.classList.contains('product-card__rating-skeleton');
        });
        if (hasYotpoContent) {
          clearTimeout(timeoutId);
          observer.disconnect();
          removeSkeleton();
        }
      });
      observer.observe(widgetEl, { childList: true, subtree: false });
      timeoutId = setTimeout(function () {
        observer.disconnect();
        removeSkeleton();
      }, TIMEOUT_MS);
    });
  }

  function reinitYotpo() {
    if (window.yotpoWidgetsContainer &&
        typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    } else {
      var waitCount = 0;
      var interval = setInterval(function () {
        waitCount++;
        if (window.yotpoWidgetsContainer &&
            typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          clearInterval(interval);
          window.yotpoWidgetsContainer.initWidgets();
        }
        if (waitCount > 30) clearInterval(interval);
      }, 100);
    }
  }
})();
